import {FC} from 'react'
import {Form} from 'react-bootstrap'
import {LegalDetail} from '../core/_models'
import '../LegalTinaDetailPage.scss'

type Props = {
  legalDetail: LegalDetail
  isLoading: boolean
  legalChildren: any[]
  onLegalChildDelete: (id: number | string) => void
}

const LegalDetailView: FC<Props> = ({legalDetail}) => {
  const renderValue = (value?: string | number | boolean | null) => {
    if (value === null || value === undefined || value === '') return '-'
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    return String(value)
  }

  return (
    <div className='detail-agreement'>
      <h3>General Information</h3>
      <div className='row mb-4'>
        <div className='col-md-6'>
          <Form.Label>Heading</Form.Label>
          <div className='data-value'>{renderValue(legalDetail.heading)}</div>
        </div>
        <div className='col-md-6'>
          <Form.Label>Unique Code</Form.Label>
          <div className='data-value'>{renderValue(legalDetail.unique_code)}</div>
        </div>
        <div className='col-md-4 mt-3'>
          <Form.Label>Parent ID</Form.Label>
          <div className='data-value'>{renderValue(legalDetail.parent_id)}</div>
        </div>
      </div>

      <hr />
      <h3>Attributes</h3>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <Form.Label>Level</Form.Label>
          <div className='data-value'>{renderValue(legalDetail.level)}</div>
        </div>

        <div className='col-md-6 mb-3'>
          <Form.Label>Divider</Form.Label>
          <div className='data-value'>
            {renderValue(legalDetail.divider == true ? 'Yes' : 'No')}
          </div>
        </div>

        <div className='col-md-6 mb-3'>
          <Form.Label>Sub Issue</Form.Label>
          <div className='data-value'>
            {renderValue(legalDetail.sub_issue == true ? 'Yes' : 'No')}
          </div>
        </div>

        <div className='col-md-6 mb-3'>
          <Form.Label>Upcoming Flag</Form.Label>
          <div className='data-value'>
            {renderValue(legalDetail.upcoming_flag == true ? 'Yes' : 'No')}
          </div>
        </div>
      </div>

      <hr />
      <h3>References</h3>
      <div className='row'>
        <div className='col-md-8 mb-3'>
          <Form.Label>Recommended Keyword</Form.Label>
          <div className='data-value'>
            {legalDetail.recommended_keyword ? (
              <div className='d-flex flex-wrap gap-2'>
                {legalDetail.recommended_keyword
                  .split(';')
                  .filter((v) => v.trim() !== '')
                  .map((keyword, idx) => (
                    <span key={idx} className='badge badge-primary'>
                      {keyword}
                    </span>
                  ))}
              </div>
            ) : (
              '-'
            )}
          </div>
        </div>
      </div>

      <hr />

      <div className='row'>
        <div className='col-md-12 mb-3'>
          <h3 className='mb-5'>Description</h3>
          <div
            className='data-value'
            dangerouslySetInnerHTML={{__html: renderValue(legalDetail.description)}}
          />
        </div>
      </div>
    </div>
  )
}

export default LegalDetailView
